import { QueryClient } from '@tanstack/react-query';

/**
 * Single shared TanStack Query client for the dashboard.
 *
 * Defaults are tuned for the file-list use case:
 *  - staleTime 30s: avoids redundant refetches while the user is browsing,
 *    but keeps things fresh enough that file mutations still feel snappy
 *    (mutations also explicitly invalidate via useFileMutationInvalidation).
 *  - gcTime 5m: drop cached query data five minutes after no observers are
 *    subscribed, so navigating between routes doesn't hold onto stale lists
 *    indefinitely.
 *  - retry: 1 keeps transient blips from cascading into long error UIs.
 *  - refetchOnWindowFocus: false — file lists are explicitly invalidated on
 *    every mutation (rename, move, delete, share, etc.) via
 *    useFileMutationInvalidation, so refetching on focus would just produce
 *    redundant network traffic. Trade-off: a tab left open in the background
 *    while another client/user changes a file won't auto-refresh until the
 *    user takes an action that invalidates the cache. Pull-to-refresh and
 *    explicit reload still work as expected.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
